import React from "react";
import Heading from "../../components/heading/Heading";

const SectionHeadingTitle = ({ text }) => {
  return (
    <Heading level={3} className="text-gray-900 text-4xl font-bold ">
      {text}{" "}
    </Heading>
  );
};

export default SectionHeadingTitle;
